import { map } from 'rxjs/operators/map';
import { ReferencePointSerializer } from '../../models';
import ajax from '../../utils/ajax';

class ReferencePointService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/status';
  configurationPathGroup = '/networkAsset/airfinder/status/locations';

  getAll = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(
      map(data => {
        let serializedResponse =
          data &&
          data.response.map(dataResponse => {
            dataResponse = ReferencePointSerializer.normalize(dataResponse);
            return dataResponse;
          });
        serializedResponse.sort((a, b) => a.healthPriority - b.healthPriority);
        return serializedResponse;
      })
    );
  };
}
export default new ReferencePointService();



// WEBPACK FOOTER //
// ./src/services/referencepointservice/index.js